import { Link } from "react-router-dom"

function HostPayment() {
  return (
	<section className="mng_bottomss user_allls profiles all_titless myprofiless">
		<div className="prfo_listst lastsst al_sec_ctxt ac_settingss">
			<div className="row">
				<div className="col-lg-8">
					<div className="discriptionns">
						<h3>Payments</h3>
					</div>

					<div className="form_al_fildss">
					 <div className="ac_seting_are">
					  <h6>Your Payments</h6>
					  <p>Keep track of all your payments and refunds.</p>
					  <Link to={'/payment'} type="text" className="butn_al_areea1" style={{color:"white"}}>Manage Payments</Link>
					 </div> 
					
					</div>
				</div>
			</div>
		</div>
	</section>
  )
}

export default HostPayment